import axios from "axios";

const VASE_U = "https://api-simulador-financiamento.azurewebsites.net/api/SimuladorFinanciamento/"

function MultiBanksApi({
  tipoImovel,
  estadoImovel,
  situacaoImovel,
  valorImovel,
  valorFinanciamento,
  valorEntrada,
  valorFGTS,
  prazo,
  nome,
  dataNascimento,
  cpf,
  renda,
  email,
  conjugeNome,
  conjugeRenda,
  totalRendaCasal,
  conjugeDataNascimento,
  proponenteNome,
  proponenteRenda,
  proponenteDataNascimento,
  proponenteNome2,
  proponenteRenda2,
  proponenteDataNascimento2,
  totalRendaProponentes,
  totalRendaSimulacao,
  id,
  telefone,
  taxaBrb,
  taxaBradesco,
  taxaCaixa,
  taxaInter,
  taxaSantander,
  taxaItau,
  adicionarSimulacao,
  setLoading,
  setDisableSelectdInter
}) {
  axios
    .post(VASE_U, {
      tipoImovel: tipoImovel,
      estadoImovel: estadoImovel,
      situacaoImovel: situacaoImovel,
      valorImovel: valorImovel,
      valorFinanciamento: valorFinanciamento,
      valorEntrada: valorEntrada || 1,
      valorFGTS: valorFGTS,
      prazo: prazo,
      nome: nome,
      dataNascimento: dataNascimento,
      cpf: cpf,
      renda: renda,
      email: email,
      conjugeNome: conjugeNome,
      conjugeRenda: conjugeRenda,
      totalRendaCasal: totalRendaCasal,
      conjugeDataNascimento: conjugeDataNascimento,
      proponenteNome: proponenteNome,
      proponenteRenda: proponenteRenda,
      proponenteDataNascimento: proponenteDataNascimento,
      proponenteNome2: proponenteNome2,
      proponenteRenda2: proponenteRenda2,
      proponenteDataNascimento2: proponenteDataNascimento2,
      totalRendaProponentes: totalRendaProponentes,
      totalRendaSimulacao: totalRendaSimulacao,
      id: id,
      telefone: telefone,
      idsTaxa: [
        taxaBrb,
        taxaBradesco,
        taxaCaixa,
        taxaInter,
        taxaSantander,
        taxaItau,
      ],
    })
    .then((response) => {
      adicionarSimulacao(response.data);
      setLoading(false);
      setDisableSelectdInter(true);
    });
}


export default MultiBanksApi;